import React, { Component } from "react";

class HeaderCheckbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: true
        }
    }

    //CHECKS (CABECERA)
    render() {

        let _state
        if (this.props.data != undefined) {
            if (this.props.index == 1)
                _state = this.props.data.checkActivo;

            if (this.props.index == 2)
                _state = this.props.data.checkBloqueado;

            if (this.props.index == 3)
                _state = this.props.data.checkBorrado;
        }

        return (<div className="checkbox-container">
            <input type="checkbox" id={this.props.title + this.props.index}
                checked={_state} value={this.props.index}
                onClick={(event) => this.setFilter(event)} />
            <label htmlFor={this.props.title + this.props.index}>{this.props.title}</label>
        </div>);
    }

    setFilter(event) {
        let currentCheck = event.target;

        if (currentCheck.value == 1)
            this.props.setActivosCheckbox(!this.props.data.checkActivo);

        if (currentCheck.value == 2)
            this.props.setBloqueadosCheckbox(!this.props.data.checkBloqueado);

        if (currentCheck.value == 3)
            this.props.setEliminadosCheckbox(!this.props.data.checkBorrado);
    }
};

export default HeaderCheckbox